export default __webpack_public_path__ + "images/rosabandet/circle-darker-pink-blur.svg";